<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">CP游戏记录-历史记录</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
              <el-table-column prop="game_name" label="游戏名称" width="150" />
              <el-table-column prop="platform_text" label="平台" width="100" />
              <el-table-column prop="version_type" label="版本类型" width="100" />
              <el-table-column prop="link" label="CP运营后台链接" width="200" />
              <el-table-column prop="created_at" label="上传时间" width="150" />
              <el-table-column prop="admin_name" label="上传人" width="100" />
              <el-table-column prop="remark" label="备注" width="150" />
              <el-table-column label="运营账号密码" width="200">
                <template slot-scope="scope">
                  <p>{{ `运营账号：${scope.row.manager_account}` }}</p>
                  <p>{{ `运营密码：${scope.row.manager_password}` }}</p>
                </template>
              </el-table-column>
              <el-table-column label="客服账号密码" width="200">
                <template slot-scope="scope">
                  <p>{{ `客服账号：${scope.row.service_account}` }}</p>
                  <p>{{ `客服密码：${scope.row.service_password}` }}</p>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCpGameAdminLog } from '@/api/dpartmentSmmary.js';
import Pagination from '@/components/pagination/index';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      listQuery: {
        id: 0,
        page: 1,
        limit: 10,
      },
      listLoading: false,
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.listQuery.id = this.$route.params.id;
    this.getList(this.listQuery);
  },
  methods: {
    // 获取列表数据
    async getList(query) {
      this.listLoading = true;
      const { data } = await getCpGameAdminLog(query);
      if (data.code !== 200) return;
      this.tableData = data.data.data;
      this.total = data.data.total;
      this.listLoading = false;
    },
  },
};
</script>

<style>
</style>